import { BirdzTitle } from '@applications-terrains/birdz-react-library';
import { Box, FormControl, FormControlLabel, Grid, Link, Radio, RadioGroup } from '@mui/material';
import React, { useState } from 'react';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { useTranslation } from 'react-i18next';
import { buildImportTemplates } from './importTemplates';

// Export CSV
export const exportToCSV = (data: any, filename = 'export.csv') => {
  const ws = XLSX.utils.aoa_to_sheet(data);
  const csv = XLSX.utils.sheet_to_csv(ws);
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  saveAs(blob, filename);
};

// Export Excel
export const exportToExcel = (data: any, filename = 'export.xlsx') => {
  const ws = XLSX.utils.aoa_to_sheet(data);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
  const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
  const blob = new Blob([excelBuffer], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  });
  saveAs(blob, filename);
};

export default function Templates() {
  const { t } = useTranslation();
  const [value, setValue] = useState<'maintenance' | 'create'>('maintenance');
  const [format, setFormat] = useState<'csv' | 'excel'>('csv');

  // Les colonnes vivent dans `importTemplates` : la refonte télécharge les mêmes
  // fichiers, et deux listes séparées finiraient par diverger.
  const templates = buildImportTemplates(t);
  const [maintenance_water] = templates.maintenance;
  const [pds_water, pds_apilink, pds_sewerin, pds_pav] = templates.create;

  const handleChange = (event: any) => {
    setValue(event.target.value);
  };

  const handleFormat = (event: any) => {
    setFormat(event.target.value);
  };

  return (
    <>
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          bgcolor: 'background.paper',
          boxShadow: 24,
          p: 4,
          minWidth: 600,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center'
        }}
      >
        <BirdzTitle>{t('bconnectMaintenanceOrder.pdsSelection.templates.importModels')}</BirdzTitle>
        <Grid container justifyContent="center" spacing={2}>
          <Grid item xs={12} display="flex" justifyContent="center">
            <FormControl>
              <RadioGroup row value={value} onChange={handleChange}>
                <FormControlLabel
                  value="maintenance"
                  control={<Radio />}
                  label={t('bconnectMaintenanceOrder.pdsSelection.templates.maintenance')}
                />
                <FormControlLabel
                  value="create"
                  control={<Radio />}
                  label={t('bconnectMaintenanceOrder.pdsSelection.templates.create')}
                />
              </RadioGroup>
            </FormControl>
          </Grid>

          <Grid item xs={12} display="flex" justifyContent="center">
            <FormControl>
              <RadioGroup row value={format} onChange={handleFormat}>
                <FormControlLabel
                  value="csv"
                  control={<Radio />}
                  label={t('bconnectMaintenanceOrder.pdsSelection.templates.csv')}
                />
                <FormControlLabel
                  value="excel"
                  control={<Radio />}
                  label={t('bconnectMaintenanceOrder.pdsSelection.templates.excel')}
                />
              </RadioGroup>
            </FormControl>
          </Grid>

          <Grid item xs={12} display="flex" flexDirection="column" alignItems="center">
            {value === 'maintenance' && (
              <>
                {/* <Box sx={{ mt: 1 }}><Link sx={{ cursor: 'pointer' }} onClick={() => format === 'csv' ? exportToCSV(data, 'maintenance_1.csv') : exportToExcel(data, 'maintenance_1.xlsx')}>Maintenance équipements uniquement</Link></Box>
                                <Box sx={{ mt: 1 }}><Link sx={{ cursor: 'pointer' }} onClick={() => format === 'csv' ? exportToCSV(data, 'maintenance_2.csv') : exportToExcel(data, 'maintenance_2.xlsx')}>Maintenance équipement et contact</Link></Box> */}
                <Box sx={{ mt: 1 }}>
                  <Link
                    sx={{ cursor: 'pointer' }}
                    onClick={() =>
                      format === 'csv'
                        ? exportToCSV(
                            [maintenance_water.columns],
                            `${maintenance_water.fileBaseName}.csv`
                          )
                        : exportToExcel(
                            [maintenance_water.columns],
                            `${maintenance_water.fileBaseName}.xlsx`
                          )
                    }
                  >
                    {t('bconnectMaintenanceOrder.pdsSelection.templates.maintenanceLink3')}
                  </Link>
                </Box>
              </>
            )}

            {value === 'create' && (
              <>
                <Box sx={{ mt: 1 }}>
                  <Link
                    sx={{ cursor: 'pointer' }}
                    onClick={() =>
                      format === 'csv'
                        ? exportToCSV([pds_water.columns], `${pds_water.fileBaseName}.csv`)
                        : exportToExcel([pds_water.columns], `${pds_water.fileBaseName}.xlsx`)
                    }
                  >
                    {t('bconnectMaintenanceOrder.pdsSelection.templates.createLink1')}
                  </Link>
                </Box>
                <Box sx={{ mt: 1 }}>
                  <Link
                    sx={{ cursor: 'pointer' }}
                    onClick={() =>
                      format === 'csv'
                        ? exportToCSV([pds_apilink.columns], `${pds_apilink.fileBaseName}.csv`)
                        : exportToExcel([pds_apilink.columns], `${pds_apilink.fileBaseName}.xlsx`)
                    }
                  >
                    {t('bconnectMaintenanceOrder.pdsSelection.templates.createLink2')}
                  </Link>
                </Box>
                <Box sx={{ mt: 1 }}>
                  <Link
                    sx={{ cursor: 'pointer' }}
                    onClick={() =>
                      format === 'csv'
                        ? exportToCSV([pds_sewerin.columns], `${pds_sewerin.fileBaseName}.csv`)
                        : exportToExcel([pds_sewerin.columns], `${pds_sewerin.fileBaseName}.xlsx`)
                    }
                  >
                    {t('bconnectMaintenanceOrder.pdsSelection.templates.createLink3')}
                  </Link>
                </Box>
                <Box sx={{ mt: 1 }}>
                  <Link
                    sx={{ cursor: 'pointer' }}
                    onClick={() =>
                      format === 'csv'
                        ? exportToCSV([pds_pav.columns], `${pds_pav.fileBaseName}.csv`)
                        : exportToExcel([pds_pav.columns], `${pds_pav.fileBaseName}.xlsx`)
                    }
                  >
                    {t('bconnectMaintenanceOrder.pdsSelection.templates.createLink4')}
                  </Link>
                </Box>
                {/* <Box sx={{ mt: 1 }}><Link sx={{ cursor: 'pointer' }} onClick={() => format === 'csv' ? exportToCSV(data, 'create_5.csv') : exportToExcel(data, 'create_5.xlsx')}>Création de pds - Bouche de lavage</Link></Box> */}
              </>
            )}
          </Grid>
        </Grid>
      </Box>
    </>
  );
}
